export default __webpack_public_path__ + "static/events-dark-fc1f6591601d42279711dc8921653e9b.png";